/**
 * Organization Stats Component
 *
 * Displays key statistics for organization management.
 */

import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Avatar
} from '@mui/material';
import {
  Business as BusinessIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  People as PeopleIcon,
  TrendingUp as TrendingUpIcon
} from '@mui/icons-material';

export default function OrganizationStats({ stats }) {
  const statCards = [
    {
      title: 'Total Organizations',
      value: stats.total_organizations,
      icon: <BusinessIcon />,
      color: '#1976d2',
      bgColor: '#e3f2fd'
    },
    {
      title: 'Active',
      value: stats.active_organizations,
      icon: <CheckCircleIcon />,
      color: '#2e7d32',
      bgColor: '#e8f5e9'
    },
    {
      title: 'Suspended',
      value: stats.suspended_organizations,
      icon: <WarningIcon />,
      color: '#ed6c02',
      bgColor: '#fff3e0'
    },
    {
      title: 'Total Users',
      value: stats.total_users,
      icon: <PeopleIcon />,
      color: '#9c27b0',
      bgColor: '#f3e5f5'
    },
    {
      title: 'New This Month',
      value: stats.organizations_created_this_month,
      icon: <TrendingUpIcon />,
      color: '#0288d1',
      bgColor: '#e1f5fe'
    }
  ];

  return (
    <Grid container spacing={3}>
      {statCards.map((stat, index) => (
        <Grid item xs={12} sm={6} md={2.4} key={index}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Avatar sx={{ bgcolor: stat.bgColor, color: stat.color, mr: 2 }}>
                  {stat.icon}
                </Avatar>
                <Typography variant="h4" component="div" sx={{ fontWeight: 'bold' }}>
                  {stat.value}
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary">
                {stat.title}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
